// extracted by mini-css-extract-plugin
export default {"productGallery":"QF-z","inQuickShop":"RF-z"};